<template>
  <OnePager v-bind="extendedOnePageProps" />
</template>

<script>
import OnePager from '@/components/OnePager'
import OnePagerMixin from '@/mixins/onepager'
import { getProductGroupFromUrlParam } from '@/utils/products'
import { SET_FORM_FIELD } from '@/utils/store/mutationTypes'
import { capitalize } from '@/utils/general'
import { OnePagerTypes } from '@/enums/signup'

export default {
  name: 'MenOriginalsSignupOnePagerChooseDesign',
  layout: 'minimal',
  components: {
    OnePager
  },
  middleware: ({ store, route }) => {
    const productGroup = getProductGroupFromUrlParam(route.params.membershipType)

    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'membershipType', value: `${productGroup}-membership` })
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'freeMembershipType', value: `${productGroup}-membership` })
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'design', value: { name: capitalize(route.params.design.replace('-', ' ')), slug: route.params.design.toLowerCase() } })
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'freeDesign', value: { name: capitalize(route.params.design.replace('-', ' ')), slug: route.params.design.toLowerCase() } })
  },
  mixins: [OnePagerMixin()],
  computed: {
    onePagerType () {
      return OnePagerTypes.minimal
    },
    extendedOnePageProps () {
      return {
        ...this.onePageProps,
        onePagerType: this.onePagerType
      }
    }
  }
}
</script>
